import React, { useContext, useState } from "react";
import ReactPlayer from "react-player";

import { faCalendarPlus, faCommentAlt } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import PaidFeatureInfoBlocks from "~/billing/PaidFeatureInfoBlocks";
import ViewportContext from "~/common/ViewportContext";
import objectivesPaywallImage from "~/legacy-assets/images/illustrations/TeamsObjectivesPaywall.svg?url";
import { Button } from "~/ui";

import styles from "./GettingStarted.module.css";

enum Steps {
	INTRO = "intro",
	VIDEO = "video",
}

const GettingStarted = ({ completeOnboarding }: { completeOnboarding: () => void }) => {
	const [step, setStep] = useState<Steps>(Steps.INTRO);

	const { isMobile } = useContext(ViewportContext);

	const setVideoStep = React.useCallback(() => {
		setStep(Steps.VIDEO);
	}, []);

	return (
		<div className={styles.container}>
			{String(step) === Steps.INTRO ? (
				<div className={styles.body}>
					<h3>
						<strong className={styles.highlighted}>Get started with objectives</strong>
					</h3>
					<p>Track progress towards your company, team, and individual objectives.</p>
					<img className={styles.okrsImage} src={objectivesPaywallImage} />
					<PaidFeatureInfoBlocks
						items={[
							{
								icon: <FontAwesomeIcon icon={faCalendarPlus} />,
								color: "peach",
								title: "Incorporate objectives into meetings",
								subtitle: "Stay on top of your goals by adding them to your team and 1-on-1 meeting agendas.",
							},
							{
								icon: <FontAwesomeIcon icon={faCommentAlt} />,
								color: "royal",
								title: "Keep your team accountable to their objectives",
								subtitle: "Share progress asynchronously with updates and comments.",
							},
						]}
					/>
					<hr className={styles.divider} />

					<div className={styles.footerText}>Have 3 minutes? Learn how to get started with objectives</div>

					<Button size="wide" onClick={completeOnboarding}>
						Skip
					</Button>
					<Button size="wide" onClick={setVideoStep} variant="primary" className={styles.watchButton}>
						Watch video tour
					</Button>
				</div>
			) : (
				<div className={styles.body}>
					<h3>
						<strong className={styles.highlighted}>Get started with objectives</strong>
					</h3>
					<p>Track progress towards your company, team, and individual objectives.</p>
					<div className={styles.videoWrapper}>
						<ReactPlayer
							fallback={<>loading...</>}
							width={isMobile ? "80vw" : "100%"}
							height={isMobile ? "50vw" : "100%"}
							url="https://play.vidyard.com/NWo8kRCdSLVx5tB8jPAyP4"
							className={styles.videoThumbnail}
						/>
					</div>
					<Button size="wide" onClick={completeOnboarding} variant="primary" className={styles.button}>
						Continue to objectives
					</Button>
				</div>
			)}

			<div className={styles.stepsGroup}>
				<div className={cx(styles.stepCircle, { [styles.activeStep]: step === Steps.INTRO })}></div>
				<div className={cx(styles.stepCircle, { [styles.activeStep]: step === Steps.VIDEO })}></div>
			</div>
		</div>
	);
};

export default GettingStarted;
